module.exports = __webpack_public_path__ + "7e4b29ba/img/boston-lights.a623432f.png";